import { useQuery } from '@tanstack/react-query';
import { adminApi } from './api.ts';

export type TeamRegion = {
  id: string;
  name: string;
  display_order: number;
  created_at: string;
  updated_at: string;
};

// Managed in Settings → Team Regions; replaces the retired branding
// option list (migration 0053).
export function useTeamRegions(enabled = true) {
  return useQuery({
    queryKey: ['team-regions'],
    queryFn: () => adminApi.get<{ team_regions: TeamRegion[] }>('/api/team-regions'),
    enabled,
  });
}

export function teamRegionNames(data: { team_regions: TeamRegion[] } | undefined): string[] {
  return (data?.team_regions ?? []).map((r) => r.name);
}
